import Vue from "vue";
const getDefaultState = () => {
  return {
    bailleurs: [],
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE_BAILLEURS(state, payload) {
    state.bailleurs = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async getListeBailleurs({ commit }) {
    // start requête

    commit("Loading/START_BUSY_STATE", "Bailleurs getListeBailleurs", {
      root: true,
    });

    let elems = [];

    try {
      await this._vm.$firebase
        .firestore()
        .collection("bailleurs")
        .orderBy("abbr_bailleur")
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              elems.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = elems.find((search) => search.id === change.doc.id);

              //bailleurs
              obj.name = change.doc.data().abbr_bailleur;
              obj.title = change.doc.data().ll_bailleur;
              obj.ll_bailleur = change.doc.data().ll_bailleur;
              obj.abbr_bailleur = change.doc.data().abbr_bailleur;
            }
            if (change.type === "removed") {
              console.log("Removed : ", change.doc.data());
              let obj = elems.find((search) => search.id === change.doc.id);
              const index = elems.indexOf(obj);
              Vue.delete(elems, index);
              //deleteProjetsDeBailleurs
            }
          });
          commit("Loading/END_BUSY_STATE", "bailleur.store.js", { root: true });
   
          commit("SET_LISTE_BAILLEURS", elems);
        });
    } catch (err) {
      console.log("Error getting collection items", err);
    }
    //end requête
  },
};

const getters = {
  bailleurs: (state) => {
    return state.bailleurs;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
